import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-success-reset',
  templateUrl: './success-reset.page.html',
  styleUrls: ['./success-reset.page.scss'],
})
export class SuccessResetPage implements OnInit {

  constructor(
    private modalCtrl: ModalController
  ) { }

  ngOnInit() {
  }

  public onAccept = () => this.modalCtrl.dismiss();

}
